import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { SvgIcon } from "@mui/material";
import './PurchasingProcess.scss';

export default function PurchasingProcess(props) {

  return (
    <Row className="purchasing-process justify-content-center">
      <Container className="mt-5">
        <Row>
          <Col className="mx-3 mb-4">
            <h2 className="text-center">{props.data.title ? props.data.title:'The Purchasing Process'}</h2>
            <p className="text-center">{props.data.subtitle}</p>
          </Col>
        </Row>
        {props.data.steps.map((step, index) =>
          <Row key={index} className="mt-3 mb-5">
            <Col md="auto" className="d-flex justify-content-center icon-wrapper-container">
              <div className="icon-wrapper mb-3" >
                <SvgIcon color="primary" component={step.icon} />
              </div>
            </Col>
            <Col className="ms-3 d-flex align-items-start justify-content-center flex-column">
              <h3 className="step-name">{step.title}</h3>
              {step.paragraphs.map((p, i) => Array.isArray(p) ?
                buildList(p, i)
                : <div key={i}>{p}</div>)
              }
            </Col>
          </Row>
        )}
      </Container>
    </Row>
  );
}

function buildList(list, index) {
  return (
    <ul key={index}>
      {list.map((listItem, i) => Array.isArray(listItem) ?
        buildList(listItem, i) :
        <li key={i}>{listItem}</li>
      )}
    </ul>
  );
}

PurchasingProcess.propTypes = {
  data: PropTypes.shape({
    subtitle: PropTypes.string,
    steps: PropTypes.array.isRequired,
  })
}
